<template>
  <adminTable
    :hideSeachButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="等级名称" width="130" />
      <el-table-column prop="extra" label="收益加成" width="130" />
      <el-table-column prop="handling_fee" label="提现手续费" width="130" />
      <el-table-column prop="team_invest" label="团队投资" width="130" />
      <el-table-column prop="recharge" label="单笔充值" width="130" />
      <el-table-column prop="cumulative_invest" label="累计投资要求" width="130" />
      <el-table-column prop="max_shares" label="最大持有股权数" width="130" />
      <!-- <el-table-column prop="lv1_invite" label="一级返利" width="130" />
      <el-table-column prop="lv2_invite" label="二级返利" width="130" /> -->
      <!-- <el-table-column prop="lv1_recharge" label="一级充值返利" width="130" />
      <el-table-column prop="lv2_recharge" label="二级充值返利" width="130" /> -->
      <el-table-column prop="create_at" label="创建时间" width="130" />
      <el-table-column prop="update_at" label="更新时间" width="130" />
      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import editPop from "./components/memberLevel/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const dialogFlag = ref(false);
const editFormRef = ref(false);
const searchForm = ref({});
const editRow = ref({});
const formType = ref("add");

onMounted(() => {
  getList();
});

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Level/getLevelLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const editItem = (type, row) => {
  console.log(type)
  console.log(row)
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "/level/deleteLevel?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const submitForm = async () => {
  const url = formType.value == "add" ? "level/addLevel" : "level/updateLevel";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      title: data.title,
      extra: data.extra,
      handling_fee: data.handling_fee,
      team_invest: data.team_invest,
      recharge: data.recharge,
      lv1_invite: data.lv1_invite,
      lv2_invite: data.lv2_invite,
      lv1_recharge: data.lv1_recharge,
      lv2_recharge: data.lv2_recharge,
      cumulative_invest: data.cumulative_invest,
      max_shares: data.max_shares,
      id: data.id
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};
</script>

<style lang="less" scoped></style>
